'use client';

import { c as _c } from "react/compiler-runtime";
import { type LoginInput as LoginSchema, loginSchema } from '@algoacademy/backend/modules/auth/contracts/login';
import { Button } from '@algoacademy/design-system/web/actions/Button';
import { Link } from '@algoacademy/design-system/web/actions/Link';
import { showErrorToast } from '@algoacademy/design-system/web/feedback/Toaster/ToasterError';
import { Checkbox, CheckboxField } from '@algoacademy/design-system/web/forms/Checkbox';
import { ErrorMessage, Field, Label } from '@algoacademy/design-system/web/forms/Fieldset';
import { Input } from '@algoacademy/design-system/web/forms/Input';
import { Label2 } from '@algoacademy/design-system/web/typography/Label';
import { P3 } from '@algoacademy/design-system/web/typography/Paragraph';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/solid';
import { zodResolver } from '@hookform/resolvers/zod';
import { useSearchParams } from 'next/navigation';
import { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { authClient } from '@/app/_auth/auth-client';
import { resolveRedirect } from '@/app/auth/_helpers/resolve-redirect';
export function LoginForm() {
  const $ = _c(52);
  const searchParams = useSearchParams();
  const redirect = resolveRedirect(searchParams.get("redirectTo") ?? searchParams.get("callbackUrl"));
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = zodResolver(loginSchema);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      resolver: t0,
      mode: "onSubmit",
      defaultValues: {
        rememberMe: false
      }
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    handleSubmit,
    control,
    register,
    formState: t2
  } = useForm(t1);
  const {
    errors
  } = t2;
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const onSubmit = async data => {
    setIsLoading(true);
    try {
      const {
        error: signInError
      } = await authClient.signIn.email({
        email: data.email,
        password: data.password,
        rememberMe: data.rememberMe
      });
      if (signInError) {
        showErrorToast("Nieprawid\u0142owy email lub has\u0142o");
        setIsLoading(false);
      } else {
        window.location.assign(redirect.url);
      }
    } catch {
      showErrorToast("Wyst\u0105pi\u0142 b\u0142\u0105d podczas logowania. Spr\xF3buj ponownie.");
      setIsLoading(false);
    }
  };
  const t3 = handleSubmit(onSubmit);
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Label>Adres email</Label>;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== register) {
    t5 = register("email");
    $[3] = register;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t5) {
    t6 = <Input type="email" placeholder="adres@email.pl" {...t5} />;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== errors.email) {
    t7 = errors.email && <ErrorMessage>{errors.email.message}</ErrorMessage>;
    $[7] = errors.email;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6 || $[10] !== t7) {
    t8 = <Field>{t4}{t6}{t7}</Field>;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Label>Hasło</Label>;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = showPassword ? "text" : "password";
  let t11;
  if ($[13] !== register) {
    t11 = register("password");
    $[13] = register;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t10 || $[16] !== t11) {
    t12 = <Input type={t10} placeholder={"Minimum 8 znak\xF3w"} {...t11} />;
    $[15] = t10;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== setShowPassword) {
    t13 = () => setShowPassword(_temp);
    $[18] = setShowPassword;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== showPassword) {
    t14 = showPassword ? <EyeIcon className="h-4 w-4" /> : <EyeSlashIcon className="h-4 w-4" />;
    $[20] = showPassword;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t13 || $[23] !== t14) {
    t15 = <button type="button" onClick={t13} className="absolute top-1/2 right-2 -translate-y-1/2 text-contentTertiary">{t14}</button>;
    $[22] = t13;
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== t12 || $[26] !== t15) {
    t16 = <div className="relative">{t12}{t15}</div>;
    $[25] = t12;
    $[26] = t15;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== errors.password) {
    t17 = errors.password && <ErrorMessage>{errors.password.message}</ErrorMessage>;
    $[28] = errors.password;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== t16 || $[31] !== t17) {
    t18 = <Field className="flex flex-col gap-2">{t9}{t16}{t17}</Field>;
    $[30] = t16;
    $[31] = t17;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== control) {
    t19 = <div className="flex items-center gap-3"><Controller name="rememberMe" control={control} render={_temp2} /></div>;
    $[33] = control;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== errors.rememberMe) {
    t20 = errors.rememberMe && <ErrorMessage>{errors.rememberMe.message}</ErrorMessage>;
    $[35] = errors.rememberMe;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== t19 || $[38] !== t20) {
    t21 = <Field>{t19}{t20}</Field>;
    $[37] = t19;
    $[38] = t20;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <Link href="/auth/forgot-password"><P3 className="font-medium text-contentNavyAlgo hover:underline">Nie pamiętasz hasła?</P3></Link>;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] !== t21) {
    t23 = <div className="flex flex-row flex-wrap items-center justify-between gap-x-2 gap-y-4">{t21}{t22}</div>;
    $[41] = t21;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  const t24 = isLoading ? "Logowanie..." : "Zaloguj";
  let t25;
  if ($[43] !== isLoading || $[44] !== t24) {
    t25 = <Button type="submit" color="algoprimary" className="w-full" disabled={isLoading}>{t24}</Button>;
    $[43] = isLoading;
    $[44] = t24;
    $[45] = t25;
  } else {
    t25 = $[45];
  }
  let t26;
  if ($[46] !== t18 || $[47] !== t23 || $[48] !== t25 || $[49] !== t3 || $[50] !== t8) {
    t26 = <form onSubmit={t3} className="space-y-4">{t8}{t18}{t23}{t25}</form>;
    $[46] = t18;
    $[47] = t23;
    $[48] = t25;
    $[49] = t3;
    $[50] = t8;
    $[51] = t26;
  } else {
    t26 = $[51];
  }
  return t26;
}
function _temp2(t0) {
  const {
    field: t1
  } = t0;
  const {
    value,
    onChange
  } = t1;
  return <CheckboxField><Checkbox checked={value} onChange={onChange} /><Label><Label2>Zapamiętaj mnie</Label2></Label></CheckboxField>;
}
function _temp(prev) {
  return !prev;
}